import { configureStore } from '@reduxjs/toolkit';
import frameReducer from './slice/frame/root_main_slice';
import loginReducer from './slice/frame/login_slice';
import cod0101mReducer from './slice/cod/cod0101m_slice';
import cod0102mReducer from './slice/cod/cod0102m_slice';
import cod0103mReducer from './slice/cod/cod0103m_slice';
import com0101mReducer from './slice/com/com0101m_slice';
import com0102mReducer from './slice/com/com0102m_slice';
import com0102pReducer from './slice/com/com0102p_slice';
import com0103mReducer from './slice/com/com0103m_slice';
import com0103pReducer from './slice/com/com0103p_slice';
import com0104mReducer from './slice/com/com0104m_slice';
import com0108mReducer from './slice/com/com0108m_slice';
import com0109mReducer from './slice/com/com0109m_slice';
import com0110mReducer from './slice/com/com0110m_slice';
import com0110pReducer from './slice/com/com0110p_slice';
import com0108pReducer from './slice/com/com0108p_slice';
import usr0101mReducer from './slice/usr/usr0101m_slice';
import usr0102mReducer from './slice/usr/usr0102m_slice';
import usr0103mReducer from './slice/usr/usr0103m_slice';
import usr0104mReducer from './slice/usr/usr0104m_slice';
import usr0201mReducer from './slice/usr/usr0201m_slice';
import usr0202mReducer from './slice/usr/usr0202m_slice';
import usr0103p1Reducer from './slice/usr/usr0103p1_slice';
import usr0301mReducer from './slice/usr/usr0301m_slice';
import usr0302mReducer from './slice/usr/usr0302m_slice';
import usr0302p2Reducer from './slice/usr/usr0302p2_slice';
import usr0302p3Reducer from './slice/usr/usr0302p3_slice';
import usr0401mReducer from './slice/usr/usr0401m_slice';
import com0101p1Reducer from './slice/com/com0101p1_slice';
import com0101p2Reducer from './slice/com/com0101p2_slice';
import com0101p3Reducer from './slice/com/com0101p3_slice';
import com0101p4Reducer from './slice/com/com0101p4_slice';
import com0113pReducer from './slice/com/com0113p_slice';
import com0114pReducer from './slice/com/com0114p_slice';
import hom0101mReducer from './slice/hom/hom0101m_slice';
import hom0101pReducer from './slice/hom/hom0101p_slice';
import hom0201mReducer from './slice/hom/hom0201m_slice';
import hom0201pReducer from './slice/hom/hom0201p_slice';
import pjt0101mReducer from './slice/pjt/pjt0101m_slice';
import pjt0102mReducer from './slice/pjt/pjt0102m_slice';
import pjt0103mReducer from './slice/pjt/pjt0103m_slice';
import pjt0103pReducer from './slice/pjt/pjt0103p_slice';
import pjt0104mReducer from './slice/pjt/pjt0104m_slice';
import pjt0105mReducer from './slice/pjt/pjt0105m_slice';
import Evl0101mReducer from './slice/evl/evl0101m_slice';
import Evl0102mReducer from './slice/evl/evl0102m_slice';
import Evl0103mReducer from './slice/evl/evl0103m_slice';
import evl0104mReducer from './slice/evl/evl0104m_slice';
import evl0104pReducer from './slice/evl/evl0104p_slice';
import Evl0105mReducer from './slice/evl/evl0105m_slice';
import Evl0106mReducer from './slice/evl/evl0110m_slice';
import Evl0107mReducer from './slice/evl/evl0107m_slice';
import Evl0108mReducer from './slice/evl/evl0108m_slice';
import Evl0109mReducer from './slice/evl/evl0109m_slice';
import Evl0109pReducer from './slice/evl/evl0109p_slice';
import Evl0110mReducer from './slice/evl/evl0110m_slice';
import Evl0111mReducer from './slice/evl/evl0111m_slice';
import Evl0112mReducer from './slice/evl/evl0112m_slice';
import Evl0112pReducer from './slice/evl/evl0112p_slice'; 

import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage/session";

import { api } from '../libs/api.service';

const persistConfig = {
  key: 'root',
  storage,
}

const reducers = combineReducers({
  Frame: frameReducer,
  Login: loginReducer,
  Cod0101m: cod0101mReducer,
  Cod0102m: cod0102mReducer,
  Cod0103m: cod0103mReducer,
  Com0101m: com0101mReducer,
  Com0103m: com0103mReducer,
  Com0103p: com0103pReducer,
  Com0104m: com0104mReducer,
  Com0102m: com0102mReducer,
  Com0102p: com0102pReducer,
  Com0109m: com0109mReducer,
  Usr0101m: usr0101mReducer,
  Usr0102m: usr0102mReducer,
  Usr0103m: usr0103mReducer,
  Usr0104m: usr0104mReducer,
  Usr0201m: usr0201mReducer,
  Usr0202m: usr0202mReducer,
  Usr0103p1: usr0103p1Reducer,
  Usr0301m: usr0301mReducer,
  Usr0302m: usr0302mReducer,
  Usr0302p2: usr0302p2Reducer,
  Usr0302p3: usr0302p3Reducer,
  Usr0401m: usr0401mReducer,
  Com0101p1: com0101p1Reducer,
  Com0101p2: com0101p2Reducer,
  Com0101p3: com0101p3Reducer,
  Com0101p4: com0101p4Reducer,
  Com0113p: com0113pReducer,
  Com0114p: com0114pReducer,
  Com0108m: com0108mReducer,
  Com0108p: com0108pReducer,
  Com0110m: com0110mReducer,
  Com0110p: com0110pReducer,
  Hom0101m: hom0101mReducer,
  Hom0101p: hom0101pReducer,
  Hom0201m: hom0201mReducer,
  Hom0201p: hom0201pReducer,
  Pjt0101m: pjt0101mReducer,
  Pjt0102m: pjt0102mReducer,
  Pjt0103m: pjt0103mReducer,
  Pjt0103p: pjt0103pReducer,
  Pjt0104m: pjt0104mReducer,
  Pjt0105m: pjt0105mReducer,
  Evl0101m: Evl0101mReducer,
  Evl0102m: Evl0102mReducer,
  Evl0103m: Evl0103mReducer,
  Evl0104m: evl0104mReducer,
  Evl0104p: evl0104pReducer,
  Evl0105m: Evl0105mReducer,
  Evl0106m: Evl0106mReducer,
  Evl0107m: Evl0107mReducer,
  Evl0108m: Evl0108mReducer,
  Evl0109m: Evl0109mReducer,
  Evl0109p: Evl0109pReducer,
  Evl0110m: Evl0110mReducer,
  Evl0111m: Evl0111mReducer,  
  Evl0112m: Evl0112mReducer, 
  Evl0112p: Evl0112pReducer, 
  
  [api.reducerPath]: api.reducer, // 반드시 추가해야 함
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false,
  }).concat(api.middleware),
})


export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const persistor = persistStore(store); 